import {
  type ColumnType,
  type Selectable,
  type Insertable,
  type Updateable,
} from 'kysely'
import { z } from 'zod'

/** Identifier type for public.cms_page_ */
export type CmsPageId = string & { __brand: 'CmsPageId' }

/** Represents the table public.cms_page_ */
export default interface CmsPageTable {
  /** Database type: pg_catalog.uuid */
  id: ColumnType<CmsPageId, CmsPageId | undefined, CmsPageId>

  /** Database type: pg_catalog.timestamptz */
  createdAt: ColumnType<Date | null, Date | string | null, Date | string | null>

  /** Database type: pg_catalog.uuid */
  createdBy: ColumnType<string | null, string | null, string | null>

  /** Database type: pg_catalog.timestamptz */
  updatedAt: ColumnType<Date | null, Date | string | null, Date | string | null>

  /** Database type: pg_catalog.uuid */
  updatedBy: ColumnType<string | null, string | null, string | null>

  /** Database type: pg_catalog.timestamptz */
  deletedAt: ColumnType<Date | null, Date | string | null, Date | string | null>

  /** Database type: pg_catalog.uuid */
  deletedBy: ColumnType<string | null, string | null, string | null>

  /** Database type: pg_catalog.text */
  pageType: ColumnType<string, string, string>

  /** Database type: pg_catalog.text */
  slug: ColumnType<string | null, string | null, string | null>

  /** Database type: pg_catalog.text */
  title: ColumnType<string | null, string | null, string | null>

  /** Database type: pg_catalog.jsonb */
  content: ColumnType<unknown, unknown | undefined, unknown>

  /** Database type: pg_catalog.bool */
  published: ColumnType<boolean, boolean | undefined, boolean>
}

export type CmsPage = Selectable<CmsPageTable>

export type CmsPageInitializer = Insertable<CmsPageTable>

export type CmsPageMutator = Updateable<CmsPageTable>

export const cmsPageId = z.string() as unknown as z.Schema<CmsPageId>

export const cmsPage = z.object({
  id: cmsPageId,
  createdAt: z.coerce.date().nullable().optional(),
  createdBy: z.string().nullable().optional(),
  updatedAt: z.coerce.date().nullable().optional(),
  updatedBy: z.string().nullable().optional(),
  deletedAt: z.coerce.date().nullable().optional(),
  deletedBy: z.string().nullable().optional(),
  pageType: z.string(),
  slug: z.string().nullable().optional(),
  title: z.string().nullable().optional(),
  content: z.unknown(),
  published: z.boolean(),
}) as unknown as z.Schema<CmsPage>

export const cmsPageInitializer = z.object({
  id: cmsPageId.optional(),
  createdAt: z.coerce.date().optional().nullable(),
  createdBy: z.string().optional().nullable(),
  updatedAt: z.coerce.date().optional().nullable(),
  updatedBy: z.string().optional().nullable(),
  deletedAt: z.coerce.date().optional().nullable(),
  deletedBy: z.string().optional().nullable(),
  pageType: z.string(),
  slug: z.string().optional().nullable(),
  title: z.string().optional().nullable(),
  content: z.unknown().optional(),
  published: z.boolean().optional(),
}) as unknown as z.Schema<CmsPageInitializer>

export const cmsPageMutator = z.object({
  id: cmsPageId.optional(),
  createdAt: z.coerce.date().optional().nullable(),
  createdBy: z.string().optional().nullable(),
  updatedAt: z.coerce.date().optional().nullable(),
  updatedBy: z.string().optional().nullable(),
  deletedAt: z.coerce.date().optional().nullable(),
  deletedBy: z.string().optional().nullable(),
  pageType: z.string().optional(),
  slug: z.string().optional().nullable(),
  title: z.string().optional().nullable(),
  content: z.unknown().optional(),
  published: z.boolean().optional(),
}) as unknown as z.Schema<CmsPageMutator>
